import type {IconType} from "react-icons";

import {FaArrowsRotate, FaArrowRotateLeft, FaPen, FaCirclePlus, FaToggleOff, FaToggleOn, FaTrashCan} from "react-icons/fa6";

import {
    FiGrid,
    FiLayers,
    FiList,
} from "react-icons/fi";

export const Icons = {
    Add: FaCirclePlus,
    Catalog: FiLayers,
    Dark: FaToggleOff,
    Delete: FaTrashCan,
    Edit: FaPen,
    Grid: FiGrid,
    Light: FaToggleOn,
    List: FiList,
    Refresh: FaArrowsRotate,
    RotateCcw: FaArrowRotateLeft,
} satisfies Record<string, IconType>;